import { Box, Button, Icon, TextField } from '@mui/material';
import DashboardLayout from 'examples/LayoutContainers/DashboardLayout';
import DashboardNavbar from 'examples/Navbars/DashboardNavbar';
import React, { useEffect, useState } from 'react';
import AptaTable from 'examples/AptaTable';
import MDTypography from 'components/MDTypography';
import axios from 'axios';
import { URL } from 'constants/constant';
import Swal from 'sweetalert2';
import { SearchInput } from 'layouts/speakers';

const MobileUsers = () => {
    const [users, setUsers] = useState([]);
    const [search, setSearch] = useState('');
    const [filteredUsers, setFilteredUsers] = useState([]);

    const getUsers = async () => {
        try {
            const response = await axios.get(`${URL}/api/iria/mobile-user`);
            if (response.data) {
                setUsers(response.data.data);
            }
        } catch (err) {
            console.error("Error fetching users:", err);
            Swal.fire("Error!", "Failed to fetch users.", "error");
        }
    };

    useEffect(() => {
        getUsers();
    }, []);

    useEffect(() => {
        if (!search) {
            setFilteredUsers(users);
        } else {
            setFilteredUsers(
                users.filter(
                    (item) =>
                        item.name?.toLowerCase().includes(search.toLowerCase()) ||
                        item.email?.toLowerCase().includes(search.toLowerCase()) ||
                        item.phoneNumber?.toLowerCase().includes(search.toLowerCase())
                )
            );
        }
    }, [search, users]);

    return (
        <DashboardLayout>
            <DashboardNavbar />
            <SearchInput searchQuery={search} handleSearchChange={(e) => {
                setSearch(e.target.value);
            }} />
            <AptaTable
                columns={['Name', 'Email', 'Phone Number']}
                rows={filteredUsers?.map((item) => ({
                    Name: <MDTypography variant="caption">{item?.name}</MDTypography>,
                    Email: <MDTypography variant="caption">{item?.email}</MDTypography>,
                    'Phone Number': <MDTypography variant="caption">{item?.phoneNumber}</MDTypography>,
                }))}
            />
        </DashboardLayout>
    );
};

export default MobileUsers;